/**
 * Async survey window helpers — client mirror of
 * supabase/functions/_shared/submission-gate.ts (kept in sync by hand;
 * the client cannot import the Deno module).
 */

export function isSurveyWindowActive(
  opensAt: string | null,
  closesAt: string | null,
  now: Date,
): boolean {
  if (!opensAt) return false;
  if (now < new Date(opensAt)) return false;
  if (closesAt && now >= new Date(closesAt)) return false;
  return true;
}

export function isSurveyWindowUpcoming(opensAt: string | null, now: Date): boolean {
  return opensAt != null && now < new Date(opensAt);
}

/** ISO timestamptz → value for <input type="datetime-local"> (local time). */
export function isoToLocalInput(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** <input type="datetime-local"> value → ISO timestamptz (or null when empty). */
export function localInputToIso(v: string): string | null {
  return v ? new Date(v).toISOString() : null;
}
